import { createFileRoute, Link, Navigate } from '@tanstack/react-router'
import { useAuthStore } from '@/store/auth'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export const Route = createFileRoute('/')({
  component: IndexComponent,
})

/** 首页：未登录展示欢迎页；已登录展示默认工作台入口与账户摘要。 */
function IndexComponent() {
  const { user, isLoading } = useAuthStore()
  
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }
  
  // 未登录时显示欢迎页面
  if (!user) {
    return (
      <div className="flex items-center justify-center py-16">
        <Card className="w-full max-w-md">
          <CardHeader className="text-center">
            <CardTitle className="text-3xl font-bold text-foreground">
              Panda Translation
            </CardTitle>
            <CardDescription className="text-lg mt-2">
              AI-Native Translation Portal
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-muted-foreground text-center">
              基于大语言模型的智能翻译平台，支持多格式文档处理、场景化翻译和术语管理。
            </p>
            <div className="flex flex-col gap-3">
              <Link to="/login">
                <Button className="w-full" size="lg">
                  登录系统
                </Button>
              </Link>
            </div>
            <div className="text-sm text-muted-foreground text-center mt-4">
              <p>核心功能：</p>
              <ul className="mt-2 space-y-1">
                <li>• 多格式文档解析（Word、Excel、PPT、PDF等）</li>
                <li>• 场景化翻译模型配置</li>
                <li>• 客户知识库与术语管理</li>
                <li>• 交互式翻译工作台</li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>
    )
  }
  
  // 已登录但未找到对应页面时，显示一个默认仪表盘
  return <Navigate to="/projects" />
}
